import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import "@/index.css";
import App from "@/App";

const container = document.getElementById("root");
const tree = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If the static HTML was produced by scripts/prerender.js it will have
// rendered DOM under #root + a marker attribute on <html>. In that case
// hydrate. Otherwise (dev server, fresh shell) mount fresh.
const isPrerendered =
  document.documentElement.getAttribute("data-prerendered") === "true" &&
  container &&
  container.firstElementChild !== null;

if (isPrerendered) {
  hydrateRoot(container, tree);
} else {
  createRoot(container).render(tree);
}
